import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../types';
import { AppTextField } from '../inputs/AppTextField';
import { capitalizeEach } from '../../utils';

export const LastNameField: React.FC<FieldProps> = ({
  margin = undefined,
  disabled = false,
  rules = { required: 'Last Name is required' },
  ...props
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      rules={rules}
      name="last_name"
      render={({ field }) => (
        <AppTextField
          {...field}
          {...props}
          onChange={e => field.onChange(capitalizeEach(e.target.value))}
          error={!!errors.last_name?.message}
          disabled={disabled}
          id="last-name"
          cy-test-id="last-name"
          label="Last Name"
          margin={margin}
          fullWidth
          helperText={(errors.last_name?.message as string) || ''}
        />
      )}
    />
  );
};
